


































import { computed, defineComponent, ref } from "@vue/composition-api";
import { LiveChatUser } from "@scrile/api-provider/dist/api/LivechatsProvider";
import BaseAvatar from "@/components/BaseAvatar";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";
import ListItem from "@/components/ListItem";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "ViewersList",
  components: { CustomScroll, BaseAvatar, ListItem, BaseInput, PageTitle },
  props: {
    userList: { type: Array as () => LiveChatUser[], required: true },
  },
  emits: ["close"],
  setup(props) {
    const term = ref("");
    const filterLoading = ref(false);

    const filteredUserList = computed<LiveChatUser[]>(() =>
      props.userList.filter(user => {
        if (!term.value.trim()) return true;
        return user.user?.screenName.includes(term.value);
      })
    );
    const setTerm = async (termValue: string) => {
      term.value = termValue;
    };
    return {
      term,
      filterLoading,
      filteredUserList,
      setTerm,
    };
  },
});
